export const _consultation = () => {
	const links = document.querySelectorAll('.l-banner__menu-link, .c-menu-mobile__item-link');

	if ( links ) {
		links.forEach( (link, i) => {
			let upperLink = link.innerHTML.toUpperCase().trim();

			if ( upperLink == 'FREE CONSULTATION' ) {
				link.classList.add('js-modal-btn');
				link.setAttribute('data-target', 'modal-consultation');
				link.setAttribute('href', 'javascript:void(0)');
			}
		})
	}
}
